// 创建 Redux Store
// 这将创建一个 Redux store，并自动配置 Redux DevTools 扩展，以便你可以在开发时检查 store。
////////
// import { configureStore } from '@reduxjs/toolkit';
// export default configureStore({
//   reducer: {},
// });
////////
// 接下来，我们需要从 counter slice 中导入 reducer 函数并将其添加到我们的 store 中。通过在 reducers 参数中定义一个字段，我们告诉 store 使用这个 slice reducer 函数来处理该 state 的所有更新。
////////
import { configureStore } from '@reduxjs/toolkit';
// 添加 Slice Reducers 到 Store
// import counterReducer from '@/pages/Test/DemoRedux/counterSlice.js'
// 添加 Slice Reducers 到 Store
// import tokenValidReducer from '@/pages/Test/DemoRedux/TokenValid/tokenValidSlice.js';
// 添加 Slice
import loginStateReducer from '@/plugin/slice/loginStateSlice.js';
import elementStateReducer from '@/plugin/slice/elementStateSlice.js';
import IPFS_Reducer from '@/plugin/slice/IPFS_Slice.js';
//
export default configureStore({
    reducer: {                    // 取值时，其实就是返回这里的对象
        IPFS_State:IPFS_Reducer,  // 取值时，IPFS_State就是键值
        loginState: loginStateReducer,
        elementState: elementStateReducer,
        // counter: counterReducer,
    },
});